import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  spaceId: number;
  domain: string;
};

const [useDeleteSpaceEmailDomain, deleteSpaceEmailDomain] = createAsyncAction(
  "spaces/deleteSpaceEmailDomain",
  async ({ spaceId, domain }: Args) => {
    const res = await API.call<{ space: string }>({
      endpoint: `spaces/${spaceId}/domains`,
      method: "DELETE",
      data: {
        domain,
      },
    });
    return { ...res, result: res.result.space };
  }
);

export default useDeleteSpaceEmailDomain;
export { deleteSpaceEmailDomain };
